import { dropStatusDocumento } from 'utils/drops';

const getOrçamentosFilterFields = (drops = {}) => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: dropStatusDocumento,
    multiple: true,
    defaultValue: ['PENDENTE'],
  },
  {
    name: 'situacao',
    label: 'Situação',
    type: 'select',
    options: drops?.StatusDocumento,
    multiple: true,
  },
  {
    name: 'dtemissao.i',
    column: 'dtemissao',
    label: 'Data de Emissão Inicial',
    type: 'date',
  },
  {
    name: 'dtemissao.f',
    column: 'dtemissao',
    label: 'Data de Emissão Final',
    type: 'date',
  },
  {
    name: 'documento',
    label: 'Nº do Documento',
    type: 'number',
    initial: true,
  },
  {
    name: 'entidade',
    label: 'Entidade',
    type: 'virtual-select',
    options: drops?.Entidade,
    multiple: true,
  },
  {
    name: 'filial',
    label: 'Filial',
    type: 'virtual-select',
    options: drops?.EntidadeTipo?.filter((f) => f?.tipo === 'FILIAL'),
    multiple: true,
  },
  {
    name: 'vldocto',
    label: 'Valor',
    type: 'currency',
  },
  {
    name: 'vendedor',
    label: 'Vendedor',
    type: 'virtual-select',
    options: drops?.EntidadeTipo?.filter(
      (f) => f?.tipo === 'VENDEDOR' || f?.tipo === 'REPRESENTANTE'
    ),
    multiple: true,
  },
  {
    name: 'validade.i',
    column: 'validade',
    label: 'Data de Validade Inicial',
    type: 'date',
  },
  {
    name: 'validade.f',
    column: 'validade',
    label: 'Data de Validade Final',
    type: 'date',
  },
  {
    name: 'forma_pagto',
    label: 'Forma de Pagamento',
  },
  {
    name: 'whatsapp',
    label: 'Contato',
  },
];

export default getOrçamentosFilterFields;
